import { render, staticRenderFns } from "./ConfiguratorStepButtons.vue?vue&type=template&id=16252acc&"
import script from "./ConfiguratorStepButtons.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorStepButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports